<template>
  <div class="animated fadeI">
    <el-form
      :model="mData.dataForm"
      :rules="mData.validForm"
      ref="myForm"
      label-position="left"
      @submit.native.prevent
      label-width="150px"
    >
      <el-card class="box-card-account-information mb-3">
        <div slot="header" class="el-card-header">
          <span class="title-card-header">Thông tin tài khoản</span>
        </div>
        <div class="">
          <b-row>
            <b-col md="6">
              <el-form-item label="Tài khoản" prop="">
                <el-input
                  v-model="mData.dataForm.user.account"
                  disabled
                  @input="forceUpdateUI"
                >
                </el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <span class="mr-3">
                Trạng thái:
                <span
                  :class="
                    mData.dataForm.user.disabled === true
                      ? 'disable'
                      : 'undisable'
                  "
                >
                  {{
                    mData.dataForm.user.disabled === true
                      ? "Đã khóa"
                      : mData.dataForm.user.disabled === false
                      ? "Đang hoạt động"
                      : ""
                  }}
                </span>
              </span>
              <el-button
                :disabled="mData.viewMode == 'detail'"
                v-if="
                  !mData.dataForm.user.disabled &&
                  mData.dataDefault.listFeature.includes('FT106')
                "
                class="pl-2"
                type="danger"
                round
                plain
                @click="fn_changeStatusAccount(true)"
                >Khoá tài khoản</el-button
              >
              <el-button
                :disabled="mData.viewMode == 'detail'"
                v-if="
                  mData.dataForm.user.disabled &&
                  mData.dataDefault.listFeature.includes('FT106')
                "
                class="pl-2"
                type="success"
                round
                plain
                @click="fn_changeStatusAccount(false)"
                >Mở tài khoản</el-button
              >
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col
              md="5"
              v-if="mData.dataDefault.listFeature.includes('FT107')"
            >
              <el-form-item label="Đặt mật khẩu mới" prop="password1">
                <el-input
                  v-model.trim="mData.dataForm.password1"
                  type="password"
                  autocomplete="off"
                  show-password
                  ref="password"
                  :disabled="
                    mData.viewMode == 'detail' || mData.dataForm.user.disabled
                  "
                >
                </el-input>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-button
                v-if="mData.dataDefault.listFeature.includes('FT107')"
                type="primary"
                round
                class="btn-default"
                :disabled="
                  mData.viewMode == 'detail' ||
                  mData.dataForm.password1 == null ||
                  mData.dataForm.user.disabled
                "
                @click="fn_changePassword"
                >Đổi mật khẩu</el-button
              >
            </b-col>
            <b-col md="12">
              <div
                class=""
                v-if="mData.dataDefault.listFeature.includes('FT107')"
              >
                <span class="mr-2"
                  >Sinh mật khẩu ngẫu nhiên và gửi vào Email nhân viên ({{
                    mData.dataDefault.employeeInfomation.administrative_info &&
                    mData.dataDefault.employeeInfomation.administrative_info.email ?
                    mData.dataDefault.employeeInfomation.administrative_info.email : ''
                  }})</span
                >
                <el-button
                  :disabled="
                    mData.viewMode == 'detail' || mData.dataForm.user.disabled
                  "
                  type="primary"
                  round
                  class="btn-default"
                  @click="fn_changeRandomPassword"
                  >Gửi Email</el-button
                >
              </div>
            </b-col>
            <!-- <b-col md="6">
              <el-form-item label="Công ty">
                <el-select
                  v-model="mData.permissionScope.company_id"
                  filterable
                  placeholder="Chọn công ty"
                  class="w-100"
                  :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT108')"
                  @change="fn_onPermissionCompanyChange"
                >
                  <el-option
                    v-for="item in mData.dataDefault.companies"
                    :key="item.id"
                    :label="fn_companyLabel(item)"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Công ty mở rộng">
                <el-select
                  v-model="mData.permissionScope.scope_company_ids"
                  multiple
                  collapse-tags
                  filterable
                  placeholder="Chọn công ty con"
                  class="w-100"
                  :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT108')"
                >
                  <el-option
                    v-for="item in mData.dataDefault.companies"
                    :key="item.id"
                    :label="fn_companyLabel(item)"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Chi nhánh quản lý">
                <el-select
                  v-model="mData.permissionScope.scope_branch_ids"
                  multiple
                  collapse-tags
                  filterable
                  placeholder="Chọn chi nhánh"
                  class="w-100"
                  :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT108')"
                >
                  <el-option
                    v-for="item in fn_branchOptions()"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Phòng ban quản lý">
                <el-select
                  v-model="mData.permissionScope.scope_department_ids"
                  multiple
                  collapse-tags
                  filterable
                  placeholder="Chọn phòng ban"
                  class="w-100"
                  :disabled="mData.viewMode == 'detail' || !mData.dataDefault.listFeature.includes('FT108')"
                >
                  <el-option
                    v-for="item in fn_departmentOptions()"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </b-col> -->
          </b-row>
        </div>
      </el-card>

      <!-- <el-card
        class="box-card-change-password mb-3"
        v-if="
          !mData.dataForm.user.disabled &&
          mData.dataDefault.listFeature.includes('FT107')
        "
      >
        <div slot="header" class="el-card-header">
          <span class="title-card-header">Thay đổi mật khẩu</span>
        </div>
        <div class="">
          <b-row>
            <b-col
              md="5"
              v-if="mData.dataDefault.listFeature.includes('FT107')"
            >
              <el-form-item label="Đặt mật khẩu mới" prop="password1">
                <el-input
                  v-model.trim="mData.dataForm.password1"
                  type="password"
                  autocomplete="off"
                  show-password
                  ref="password"
                  :disabled="
                    mData.viewMode == 'detail' || mData.dataForm.user.disabled
                  "
                >
                </el-input>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-button
                v-if="mData.dataDefault.listFeature.includes('FT107')"
                type="primary"
                round
                class="btn-default"
                :disabled="
                  mData.viewMode == 'detail' ||
                  mData.dataForm.password1 == null ||
                  mData.dataForm.user.disabled
                "
                @click="fn_changePassword"
                >Đổi mật khẩu</el-button
              >
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <div
                class=""
                v-if="mData.dataDefault.listFeature.includes('FT107')"
              >
                <span class="mr-2"
                  >Sinh mật khẩu ngẫu nhiên và gửi vào Email nhân viên ({{
                    mData.dataDefault.employeeInfomation.administrative_info &&
                    mData.dataDefault.employeeInfomation.administrative_info.email ?
                    mData.dataDefault.employeeInfomation.administrative_info.email : ''
                  }})</span
                >
                <el-button
                  :disabled="
                    mData.viewMode == 'detail' || mData.dataForm.user.disabled
                  "
                  type="primary"
                  round
                  class="btn-default"
                  @click="fn_changeRandomPassword"
                  >Gửi Email</el-button
                >
              </div>
            </b-col>
          </b-row>
        </div>
      </el-card> -->

      <el-card
        class="box-card-decentralization mb-3"
        v-if="!mData.dataForm.user.disabled"
      >
        <div slot="header" class="el-card-header">
          <span class="title-card-header">Phân quyền</span>
        </div>
        <div class="">
          <b-row class="mb-3">
            <b-col md="12">
              <span>Nhóm quyền</span>
            </b-col>
            <b-col md="12" class="ml-4 mt-3">
              <el-checkbox-group
                v-model="mData.rolesChecked"
                class=""
              >
                <b-row>
                  <b-col
                    lg="3"
                    md="4"
                    v-for="item in mData.dataDefault.roles"
                    :key="item.id"
                  >
                    <el-checkbox
                      :disabled="
                        mData.viewMode == 'detail' ||
                        !mData.dataDefault.listFeature.includes('FT108') ||
                        mData.dataForm.user.disabled ||
                        item.disabled
                      "
                      :label="item.id"
                      >{{ item.name }}</el-checkbox
                    >
                  </b-col>
                </b-row>
              </el-checkbox-group>
            </b-col>
          </b-row>
        </div>
      </el-card>
    </el-form>
  </div>
</template>

<script>
import ValidService from "../../service/ValidService";
import MethodService from "../../service/MethodService";
import EventBus from "../../service/EventBus";
import EmployeeModel from "../../views/admin/Employees/EmployeeModel";
import UserApi from "../../moduleApi/UserApi";
import RoleApi from "../../moduleApi/RoleApi";
import EmployeeApi from "../../moduleApi/EmployeeApi";
import EmployeeRoleApi from "../../moduleApi/EmployeeRoleApi";
import CompanyApi from "../../moduleApi/CompanyApi";

export default {
  data() {
    return {
      checkList: [],
      mData: {
        rolesChecked: [],
        moduleName: "EmployeeManager", //requied
        tableRules: MethodService.copyObject(EmployeeModel.tableRules),
        dataForm: {
          user: {
            id: undefined,
            account: undefined,
            disabled: undefined,
          },
          password1: undefined,
        },
        permissionScope: {
          company_id: undefined,
          scope_company_ids: [],
          scope_branch_ids: [],
          scope_department_ids: [],
        },
        validForm: {
          password1: [
            ValidService.required,
            ValidService.checkSpaceString,
            ValidService.checkSign,
            ValidService.requiredChange,
            ValidService.checkMinLength(6)
          ],
        },
        showTableDetail: false,
        employeeId: "",
        data: [],
        dataDefault: {
          listFeature: [],
          listFeatureByCompany: [],
          roles: [],
          employeeInfomation: {},
          employeeFeature: undefined,
          employeeRoles: undefined,
          companies: [],
          branches: [],
          departments: [],
          listFeature: MethodService.getListFeatures(),
        },
        companyInfo: {},
      },
    };
  },
  methods: {
    async fn_initData() {
      this.mData.companyInfo = MethodService.getCompanyInfo();
      this.mData.permissionScope.company_id = this.mData.companyInfo.id;
      await this.fn_loadCompanyScopeOptions();
      await this.fn_loadRolesByCompany(this.mData.permissionScope.company_id);
    },
    async fn_loadCompanyScopeOptions() {
      try {
        const res = await CompanyApi.GetCompanyFilterOptions({}, true);
        const result = res.result || {};
        this.mData.dataDefault.companies = result.companies || [];
        this.mData.dataDefault.branches = result.branches || [];
        this.mData.dataDefault.departments = result.departments || [];
      } catch (error) {
        this.mData.dataDefault.companies = this.mData.companyInfo && this.mData.companyInfo.id ? [this.mData.companyInfo] : [];
        this.mData.dataDefault.branches = [];
        this.mData.dataDefault.departments = [];
      }
    },
    async fn_loadRolesByCompany(companyId) {
      const filters = companyId ? `disabled!=true&company_id=${companyId}` : `disabled!=true`;
      const roleApiRes = await RoleApi.list({
        filters,
        limit: 100
      });
      this.mData.dataDefault.roles = roleApiRes.result || [];
      this.mData.rolesChecked = this.mData.rolesChecked.filter(roleId =>
        this.mData.dataDefault.roles.some(role => role.id == roleId)
      );
    },
    async fn_getDataById(id) {
      setTimeout(() => {
        this.$refs["myForm"].resetFields();
      }, 100)
      this.mData.rolesChecked = [];
      const employeeApiRes =  await EmployeeApi.findById(id);
      const userApiRes = await UserApi.findById(id);
      const employeeRoleApiRes = await EmployeeRoleApi.list({
        filters: "employee_id=" + id,
      });
      // debugger
      if(employeeApiRes.result){
        this.mData.dataDefault.employeeInfomation = employeeApiRes.result;
        this.mData.permissionScope.company_id = employeeApiRes.result.company_id || this.mData.companyInfo.id;
        await this.fn_loadRolesByCompany(this.mData.permissionScope.company_id);
      }
      if (userApiRes.result) {
        this.mData.dataForm.user = userApiRes.result;
      } else {
        this.mData.dataForm.account = "";
        this.mData.dataForm.disabled = false;
      }
      if (employeeRoleApiRes.result && employeeRoleApiRes.result.length > 0) {
        this.mData.dataDefault.employeeRoles = employeeRoleApiRes.result[0];
        this.mData.rolesChecked = this.mData.dataDefault.employeeRoles.role_ids;
        this.mData.permissionScope.company_id = this.mData.dataDefault.employeeRoles.company_id || this.mData.permissionScope.company_id;
        this.mData.permissionScope.scope_company_ids = this.mData.dataDefault.employeeRoles.scope_company_ids || [];
        this.mData.permissionScope.scope_branch_ids = this.mData.dataDefault.employeeRoles.scope_branch_ids || [];
        this.mData.permissionScope.scope_department_ids = this.mData.dataDefault.employeeRoles.scope_department_ids || [];
        await this.fn_loadRolesByCompany(this.mData.permissionScope.company_id);
      } else {
        this.mData.dataDefault.employeeRoles = undefined;
        this.mData.permissionScope.scope_company_ids = [];
        this.mData.permissionScope.scope_branch_ids = [];
        this.mData.permissionScope.scope_department_ids = [];
      }
    },
    fn_changeData(resData) {
      resData.forEach((item) => {
        let featureName = this.mData.dataDefault.listFeature.find((element) => {
          return element.id == item.feature_id;
        });
        if (featureName && featureName.name) {
          item.feature_name = featureName.name;
        } else {
          item.feature_name = " ";
        }
      });
      return resData;
    },
    async fn_submit(type) {
      if (type == "update") {
        let data = {};
        data.employee_id = this.$router.currentRoute.params.id;
        data.company_id = this.mData.permissionScope.company_id || this.mData.companyInfo.id;
        data.scope_company_ids = this.mData.permissionScope.scope_company_ids || [];
        data.scope_branch_ids = this.mData.permissionScope.scope_branch_ids || [];
        data.scope_department_ids = this.mData.permissionScope.scope_department_ids || [];
        // data.feature_ids = this.checkList;
        data.role_ids = this.mData.rolesChecked;
        if (this.mData.dataDefault.employeeRoles) {
          data.id = this.mData.dataDefault.employeeRoles.id;
          try {
            await EmployeeRoleApi.update(data);
            window.toastr.success("Cập nhật thành công!");
          } catch (error) {
            window.toastr.error("Cập nhật thất bại!");
          }
        } else {
          try {
            await EmployeeRoleApi.create(data);
            window.toastr.success("Cập nhật thành công!");
          } catch (error) {
            window.toastr.error("Cập nhật thất bại!");
          }
        }
        this.fn_getDataById(this.$router.currentRoute.params.id);
      }
    },
    async fn_changeStatusAccount(status) {
      let data = {};
      this.$confirm(
        `Bạn có chắc chắn muốn ${
          status === true ? "khóa" : "mở khóa"
        } tài khoản này? `,
        "Thông báo",
        {
          confirmButtonText: `${status === true ? "Khóa" : "Mở khóa"}`,
          cancelButtonText: "Hủy",
          type: "warning",
        }
      )
        .then(async () => {
          data.employeeId = this.mData.dataForm.user.id;
          // data.disabled = status;
          if (status === true) {
            try {
              await EmployeeApi.lockUser(data);

              this.fn_getDataById(this.$router.currentRoute.params.id);
            } catch (error) {}
          } else {
            try {
              await EmployeeApi.unLockUser(data);
              this.fn_getDataById(this.$router.currentRoute.params.id);
            } catch (error) {}
          }
        })
        .catch(() => {});
    },
    fn_changePassword() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let data = {};
          data.password = this.mData.dataForm.password1;
          data.employeeId = this.$router.currentRoute.params.id;
          try {
            await EmployeeApi.resetPassword(data);
            window.toastr.success("Đổi mật khẩu thành công!");
            // this.mData.dataForm.password1 = undefined;
            this.$refs['myForm'].fields.find((f) => f.prop == "password1").resetField()
          } catch (error) {
            window.toastr.error("Đổi mật khẩu thất bại!");
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    async fn_changeRandomPassword() {
      let data = {};
      data.employeeId = this.$router.currentRoute.params.id;
      try {
        await EmployeeApi.resetPassword(data);
        window.toastr.success("Sinh mật khẩu và gửi email thành công!");
      } catch (error) {
        window.toastr.error("Sinh mật khẩu và gửi email thất bại!");
      }
    },
    async handleClick(e) {
      if (e.target.matches(".form-check-input")) {
        this.checkList.push(e.target.defaultValue);
      }
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    async fn_onPermissionCompanyChange() {
      this.mData.rolesChecked = [];
      this.mData.permissionScope.scope_branch_ids = this.mData.permissionScope.scope_branch_ids.filter(branchId =>
        this.fn_branchOptions().some(branch => branch.id == branchId)
      );
      this.mData.permissionScope.scope_department_ids = this.mData.permissionScope.scope_department_ids.filter(departmentId =>
        this.fn_departmentOptions().some(department => department.id == departmentId)
      );
      await this.fn_loadRolesByCompany(this.mData.permissionScope.company_id);
    },
    fn_branchOptions() {
      if (!this.mData.permissionScope.company_id) return this.mData.dataDefault.branches;
      return this.mData.dataDefault.branches.filter(item => item.company_id == this.mData.permissionScope.company_id);
    },
    fn_departmentOptions() {
      if (!this.mData.permissionScope.company_id) return this.mData.dataDefault.departments;
      return this.mData.dataDefault.departments.filter(item => item.company_id == this.mData.permissionScope.company_id);
    },
    fn_companyLabel(item) {
      if (!item) return "";
      const name = item.name && (item.name.name_vi || item.name.Name_vi) ? (item.name.name_vi || item.name.Name_vi) : item.name;
      const prefix = item.level ? `${"— ".repeat(item.level)}` : "";
      return `${prefix}${name || item.id}`;
    },
  },
  async created() {
    await this.fn_initData();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-create"
    ) {
      this.mData.viewMode = "create";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "update";
    }
    if (this.$router.currentRoute.params.id) {
      this.mData.employeeId = this.$router.currentRoute.params.id;
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
    EventBus.$off("click_PhanQuyen");
    EventBus.$off("rowClick_PhanQuyen");
    EventBus.$off("tab_PhanQuyen");
    EventBus.$on("click_PhanQuyen", (data) => {
      if (data.type_button == "update") {
        this.fn_submit("update");
      }
    });
    EventBus.$on("rowClick_PhanQuyen", (data) => {
      this.fn_getDataById(data.id);
    });
    EventBus.$on("tab_PhanQuyen", () => {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    });
  },
  mounted() {},
};
</script>

<style scoped>
.d-flex_cus {
  display: flex;
  flex-wrap: wrap;
}
.title-card-header {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}
::v-deep .el-checkbox {
  margin-right: 15px;
}
::v-deep .el-collapse {
  border: 1px solid #ebeef5;
  background-color: #fff;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}
::v-deep .el-form-item__label {
  margin-bottom: 0;
}
::v-deep .el-collapse-item__header {
  background-color: #fff !important;
  border-radius: 4px;
}
::v-deep table,
thead,
tr,
tbody,
th,
td {
  text-align: center;
}
::v-deep .table td {
  vertical-align: inherit;
}
::v-deep .table td {
  vertical-align: inherit;
}
::v-deep .form-check-input {
  position: unset;
  margin-top: 0;
  margin-left: 0;
}
::v-deep .form-check-input:hover {
  cursor: pointer;
}
.undisable {
  color: rgb(0, 167, 0);
  font-weight: bold;
}
.disable {
  color: red;
  font-weight: bold;
}
.d-flex1 {
  display: flex;
  flex-direction: column;
  max-width: 340px;
  align-items: center;
}
.d-flex1 button {
  margin-top: 10px;
  max-width: 90px;
}
</style>
